'use strict';

/**
 * Reusable slick carousel configurations
 * @example - $('.product-carousel').slick(slickConfigs.pdp)
 */

module.exports = {
    pdPromoBanner: {
        pauseOnFocus: true,
        accessibility: true,
        infinite: true,
        speed: 300,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><span class="svgicon svg-promo-banner-slick-arrow svg-promo-banner-slick-arrow-dims"></span></button>',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><span class="svgicon svg-promo-banner-slick-arrow svg-promo-banner-slick-arrow-dims"></span></button>'
    }
};
